import React, { useState, useEffect, useMemo, useCallback } from "react";
import List from "../List";

const initialUsers = [
    // { id: 1, name: "Luis", topic: "Topic1", message: "Mensaje1" },
    // { id: 2, name: "Maria", topic: "Topic2", message: "Mensaje2" },
    { id: 1, topic: "Topic1", message: "Mensaje1" },
    { id: 2, topic: "Topic2", message: "Mensaje2" },
];

const Hw1 = () => {
  //console.log("render");
  const [users, setUsers] = useState(initialUsers);
  const [text_topic, setText_topic] = useState("");
  const [text_message, setText_message] = useState("");
  const [search, setSearch] = useState("");

  const [scrollY, setScrollY] = useState(0);
  const [color, setColor] = useState("orange");

  const handleAdd = () => {
    var index = -1
    for(var i = 0; i < users.length; i++) {
        if(users[i].topic === text_topic) {
            index = i;
            break;
        }
    }
    console.log(index);

    if (index > -1) {  // si existe modificamos el item
      /*
      console.log("ya existe modificamos el item");
      users[index].message = text_message;
      const newState = users;
      setUsers( newState );
      */

      //const editar=()=>{
        //var dataNueva=data;
        var usersNueva=users;
        usersNueva.map(pais=>{
          //if(pais.id===paisSeleccionado.id){
        if(pais.topic===text_topic){
          //pais.minutos=paisSeleccionado.minutos;
          pais.message=text_message;

          //pais.nombre=paisSeleccionado.nombre;
          }
        });
        //setData(dataNueva);
        setUsers(usersNueva);
        //setModalEditar(false);
      //}
      }
    

    else {  //no existe añadimos el item
      console.log("no existe añadimos...");
      //valorInsertar.id=data[data.length-1].id+1;
      const newUser = { 
        id: Date.now(), 
        topic: text_topic, 
        message: text_message 
      };
      setUsers([...users, newUser]);
      }

    // *********

  };  // fin handleAdd

  const handleDelete = useCallback(
    (userId) => {
      setUsers(users.filter((user) => user.id !== userId));
    }, [users]
  );

  const handleSearch = () => {
    //console.log("Search");
    setSearch(text_topic);
  };

  const filteredUsers = useMemo(
    () =>
      users.filter((user) => {
        //console.log("Filter process");
        // return user.name.toLowerCase().includes(search.toLowerCase());
        return user.topic.toLowerCase().includes(search.toLowerCase());
      }),
    [search, users]
  );

  const printUsers = useCallback(() => {
    // console.log("changed users", users);
  }, [users])

  useEffect(() => {
    //console.log("App render");
  })

  useEffect(() => {
    //console.log("changed users");
    printUsers();

    const detectarScroll = () => setScrollY(window.pageYOffset);
    //   var VN1 = this.name.substring(this.name.lastIndexOf("_")+1);
    var VN1 = "pr1";
    window.addEventListener("scroll", detectarScroll);
    //window.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mqtt1Rx1", onMsg1);
    // document.addEventListener(VN1, ChangeValue);
    //document.dispatchEvent(new CustomEvent("mqtt1Rx1", {detail: { name: VN1, values: JSON.stringify(objLocal1) } }));

    function onMsg1(event) {
        // const name = event.detail.name;
        // const number = event.target.dataset.num;
        // console.log(`Message received from ${name} (${number})`);
    
        console.log( event.detail );
        if (Object.values(users).indexOf(event.detail.topic) > -1) {
          //valorInsertar.id=data[data.length-1].id+1;
          const newUser = { id: Date.now(), topic: JSON.stringify(event.detail.topic), 
            message: JSON.stringify(event.detail.message) };
          setUsers([...users, newUser]);
        }
        else {

        }

    }

    return () => {
        window.removeEventListener("scroll", detectarScroll);
        //window.removeEventListener("mousemove", onMouseMove);
        // document.removeEventListener(VN1, ChangeValue);
        document.removeEventListener("mqtt1Rx1", onMsg1);
    };  
  }, [users, printUsers, scrollY]);

  return (
    // <div style={{height: "100vh", background: color }} >
    <div style={{ background: color }} >
      <p>Scroll Y del Navegador {parseInt(scrollY)}px </p>
      <input
        type="text"
        value={text_topic}
        onChange={(e) => setText_topic(e.target.value)}
      />
      <input

   type="text"
        value={text_message}
        onChange={(e) => setText_message(e.target.value)}
      />
      <button onClick={handleSearch}>Search</button>
      <button onClick={handleAdd}>Add</button>
      <div>
      <List users={filteredUsers} handleDelete={handleDelete} />
      </div>
    </div>
  );
};

export default Hw1;
